function e(t) {
  return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(t);
}

function t(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function n(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}

function i(e, t) {
  if (null == e) return {};

  var n,
      i,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        i,
        o = {},
        r = Object.keys(e);

    for (i = 0; i < r.length; i++) {
      n = r[i], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);

    for (i = 0; i < r.length; i++) {
      n = r[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

function o(e, t) {
  var n = t.get(e);
  if (!n) throw new TypeError("attempted to get private field on non-instance");
  return n.get ? n.get.call(e) : n.value;
}

var r = {
  player: "lottie-player"
},
    a = function () {
  function a() {
    var n = this,
        u = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r,
        c = u.actions,
        f = u.container,
        d = u.mode,
        m = u.player,
        v = i(u, ["actions", "container", "mode", "player"]);

    if (t(this, a), s.set(this, {
      writable: !0,
      value: function value(e) {
        o(n, y).call(n, e.clientX, e.clientY);
      }
    }), l.set(this, {
      writable: !0,
      value: function value() {
        o(n, y).call(n, -1, -1);
      }
    }), y.set(this, {
      writable: !0,
      value: function value(e, t) {
        if (-1 !== e && -1 !== t) {
          var i = n.getContainerCursorPosition(e, t);
          e = i.x, t = i.y;
        }

        var o = n.actions.find(function (n) {
          var i = n.position;
          return Array.isArray(i.x) && Array.isArray(i.y) ? e >= i.x[0] && e <= i.x[1] && t >= i.y[0] && t <= i.y[1] : !Number.isNaN(i.x) && !Number.isNaN(i.y) && e === i.x && t === i.y;
        });
        if (o) if ("seek" === o.type) {
          var r = (e - o.position.x[0]) / (o.position.x[1] - o.position.x[0]),
              a = (t - o.position.y[0]) / (o.position.y[1] - o.position.y[0]);
          n.player.playSegments(o.frames, !0), o.position.y[0] < 0 && o.position.y[1] > 1 ? n.player.goToAndStop(Math.floor(r * n.player.totalFrames), !0) : n.player.goToAndStop(Math.ceil((r + a) / 2 * n.player.totalFrames), !0);
        } else "loop" === o.type ? n.player.playSegments(o.frames, !0) : "play" === o.type ? (!0 === n.player.isPaused && n.player.resetSegments(), n.player.playSegments(o.frames)) : "stop" === o.type && n.player.goToAndStop(o.frames[0], !0);
      }
    }), p.set(this, {
      writable: !0,
      value: function value() {
        var e = n.getContainerVisibility(),
            t = n.actions.find(function (t) {
          var n = t.visibility;
          return e >= n[0] && e <= n[1];
        });
        t && ("seek" === t.type ? n.player.goToAndStop(Math.ceil((e - t.visibility[0]) / (t.visibility[1] - t.visibility[0]) * n.player.totalFrames), !0) : "loop" === t.type ? (n.player.loop = !0, (null === n.assignedSegment || n.assignedSegment !== t.frames || !0 === n.player.isPaused) && (n.player.playSegments(t.frames, !0), n.assignedSegment = t.frames)) : "play" === t.type ? n.scrolledAndPlayed || (n.scrolledAndPlayed = !0, n.player.resetSegments(!0), n.player.play()) : "stop" === t.type && n.player.goToAndStop(t.frames[0], !0));
      }
    }), "object" !== e(m) || "AnimationItem" !== m.constructor.name) {
      if ("string" == typeof m) {
        var g = document.querySelector(m);
        g && "LOTTIE-PLAYER" === g.nodeName && (m = g.getLottie());
      } else m instanceof HTMLElement && "LOTTIE-PLAYER" === m.nodeName && (m = m.getLottie());

      if (!m) throw new Error("".concat("[lottieInteractivity]:", " Specified player is invalid."), m);
    }

    "string" == typeof f && (f = document.querySelector(f)), f || (f = m.wrapper), this.player = m, this.container = f, this.mode = d, this.actions = c, this.options = v, this.assignedSegment = null, this.scrolledAndPlayed = !1;
  }

  var u, c, f;
  return u = a, (c = [{
    key: "getContainerVisibility",
    value: function value() {
      var e = this.container.getBoundingClientRect(),
          t = e.top,
          n = e.height;
      return (window.innerHeight - t) / (window.innerHeight + n);
    }
  }, {
    key: "getContainerCursorPosition",
    value: function value(e, t) {
      var n = this.container.getBoundingClientRect(),
          i = n.top;
      return {
        x: (e - n.left) / n.width,
        y: (t - i) / n.height
      };
    }
  }, {
    key: "start",
    value: function value() {
      var e = this;
      "scroll" === this.mode && this.player.addEventListener("DOMLoaded", function () {
        e.player.stop(), window.addEventListener("scroll", o(e, p));
      }), "cursor" === this.mode && this.player.addEventListener("DOMLoaded", function () {
        e.player.loop = !0, e.player.stop(), e.container.addEventListener("mousemove", o(e, s)), e.container.addEventListener("mouseout", o(e, l));
      });
    }
  }, {
    key: "stop",
    value: function value() {
      "scroll" === this.mode && window.removeEventListener("scroll", o(this, p)), "cursor" === this.mode && (this.container.addEventListener("mousemove", o(this, s)), this.container.addEventListener("mouseout", o(this, l)));
    }
  }, {
    key: "animate",
    value: function value(e) {
      var t = e.timing,
          n = e.draw,
          i = e.duration,
          o = performance.now();
      requestAnimationFrame(function e(r) {
        var a = (r - o) / i;
        a > 1 && (a = 1);
        var s = t(a);
        n(s), a < 1 && requestAnimationFrame(e);
      });
    }
  }]) && n(u.prototype, c), f && n(u, f), a;
}(),
    s = new WeakMap(),
    l = new WeakMap(),
    y = new WeakMap(),
    p = new WeakMap(),
    u = function u(e) {
  var t = new a(e);
  return t.start(), t;
};

export default u;
export { a as LottieInteractivity, u as create };